export const ROUTES = {
  dashboard: "/",
  profile: "/profile",
  signup: "/signup",
  signupSuccess: "/signup-success"
}
